<template>
  <div
    :class="{
      commenting: floating,
      fade: floating,
    }"
    @mouseover="onHover"
    @mouseleave="hover = false"
  >
    <v-slide-x-transition>
      <app-audio-player
        v-show="(asPlayer && !floating) || (showPlayer && player)"
        ref="player"
        v-bind="$attrs"
        :src="src"
        :short="!asPlayer || floating || short"
        :class="{ 'absolute widder': !asPlayer || floating }"
        :style="!asPlayer || floating ? 'min-width: 350px' : ''"
        @play="icon = 'mdi-stop'"
        @pause="icon = playIcon"
      />
    </v-slide-x-transition>
    <app-button
      v-if="!asPlayer || floating"
      :icon="icon"
      :size="24"
      @click.native="onCLick"
    />
  </div>
</template>
<script>
import Button from '@/components/Lessons/Lesson/components/Button.vue';
import AudioPlayer from './AudioPlayer.vue';
import debounce from 'debounce';

export default {
  components: {
    AppButton: Button,
    AppAudioPlayer: AudioPlayer,
  },
  props: {
    src: String,
    player: {
      /*
       * Determines wheter the button should display
       * the audio player or not
       */
      type: Boolean,
      default: true,
      required: false,
    },
    /*
    * Small and pink player
    */
    short: Boolean,
    playIcon: {
      type: String,
      default: '$vuetify.icons.appSpeaker',
    },
    asPlayer: {
      type: Boolean,
      default: false,
    },
    floating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
      showPlayer: false,
      icon: this.playIcon,
    };
  },
  methods: {
    onLeave() {
      this.hover = false;
    },
    onHover() {
      this.hover = true;
      this.showPlayer = true;
    },
    onCLick() {
      this.$refs.player.onClick();
    },
  },
  watch: {
    hover: debounce(function() {
      if (!this.hover) {
        this.showPlayer = false;
      }
    }, 200),
  },
};
</script>
<style scoped>
.widder {
  margin-top: -100px !important;
  left: -250px;
}
.commenting {
  position: fixed;
  bottom: 1rem;
  right: 3rem;
  z-index: 250;
  animation: slideLeft 0.4s linear;
}

.fade {
  animation: fade 0.5s linear;
}

@keyframes slideLeft {
  0% {
    right: 50px;
    opacity: 0;
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.8);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
